// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pm_a bhn_ea bhn_ke bhn_ju bhn_a bhn_j bhn_so bhn_sp","SearchPanel__icon":"pm_b bhn_vo bhn_hi bhn_su bhn_va","SearchPanel__input":"pm_c bhn_jb bhn_eg bhn_z"};